import { compose, setDisplayName, withState } from 'recompose';

const enhance = compose(
  setDisplayName('ImageEditModalBody'),
  withState('loading', 'setLoading', false)
);

export default enhance;
